import type { Cart } from 'core';

const INITIAL_VALUE = 1;

/**
 * Responsible for Pluralizing a word singularize if quantity bigger than 1 and
 * apply the value zero to the initial of the string when the quantity is less than 10.
 *
 */
export function formatTotalUnitPlural(
  totalUnitCount: Cart['data']['totalUnitCount'] = INITIAL_VALUE,
) {
  const isTotalUnitMoreThanOne = totalUnitCount > INITIAL_VALUE;

  return (isTotalUnitMoreThanOne ? `${totalUnitCount} itens` : `${totalUnitCount} item`).padStart(
    isTotalUnitMoreThanOne ? 8 : 7,
    '0',
  );
}
